module.exports = __webpack_public_path__ + "static/media/discover.9bfbc4d7.png";